import { TableCell, TableRow } from "@material-ui/core";
import Table from 'react-bootstrap/Table'
import "../../css/ExpandableRow.css"
import React from 'react';
import { Component } from "react";
import axiosInstance from "../../axiosInstance";
import { logOut, make_select_data } from "../helper";
import { Button } from "react-bootstrap";
import axios from "axios";
import StbForm from "./StbForm";
import Onu from "./Onu";
class ExpandableRow extends Component {

    constructor(props) {
        super(props)
        this.state = {
            text: "",
            data: this.props.data,
            columns: this.props.columns,
            comments: [],
            stb_packages:[],
            internet_packages:[],
            tv_brands: [],
            source:axios.CancelToken.source()
        }
        this.wrapper = React.createRef();
    }


    componentDidMount() {
        this.fetch_comments();
        this.fetch_tv_brands();
        this.fetch_stb_packages();
        this.fetch_internet_packages();
    }

    componentWillUnmount(){
        this.state.source.cancel();
    }

    fetch_tv_brands() {
        axiosInstance.get('/tv_brands',{
            cancelToken:this.state.source.token
        })
            .then(response => {
                this.setState({
                    tv_brands: make_select_data(response.data.data)
                })
            })
            .catch(err => {
                if (err.response?.status === 401) {
                    logOut(this.props);
                }
            })
    }

    fetch_stb_packages(){
        axiosInstance.get('/billing/stb/packages/all',{
            cancelToken:this.state.source.token
        })
            .then(response => {
                var array = [];
                response.data.data.forEach(function (element) {
                    array.push({
                        value: element.id,
                        label: element.name
                    })
                });
                this.setState({
                    stb_packages: array
                })
            })
            .catch(err => {
                if (err.response?.status === 401) {
                    logOut(this.props);
                }
            })
    }
    fetch_internet_packages(){
        axiosInstance.get('/billing/internet/packages/all',{
            cancelToken:this.state.source.token
        })
            .then(response => {
                var array = [];
                response.data.data.forEach(function (element) {
                    array.push({
                        value: element.id,
                        label: element.name
                    })
                });
                this.setState({
                    internet_packages: array
                })
            })
            .catch(err => {
                if (err.response?.status === 401) {
                    logOut(this.props);
                }
            })
    }

    on_comment_fetch(data) {
        this.setState({
            comments: data
        })
    }
    fetch_comments(id) {
        axiosInstance.get('tickets/' + this.props.data.id + '/comments',{
            cancelToken:this.state.source.token
        })
            .then(response =>{
                this.setState({
                    comments:response.data.data
                })
            })
            .catch(err => { 
                if (err.response?.status === 401) {
                    logOut(this.props);
                }
            })
    }
    make_info() {
        let data = this.state.data
        let arr = [];
        for (let i = 0; i < this.props.columns.length; i++) {
            if(this.state.data.provider_id == 10 &&
                (this.props.columns[i].name == 'internet_speed' || this.props.columns[i].name == 'internet_provider'))
                {
                    continue;
            }
            arr.push(
                <tr key={i}>
                    <td>{this.props.columns[i].label}</td>
                    <td>{data[this.props.columns[i].name]}</td>
                </tr>
            )
        }
        return arr
    }



    on_comment_add() {
        this.fetch_comments();
        this.setState({
            text: ""
        })
    }

    add_comment() {
        let text = this.state.text;
        if (text !== "") {
            axiosInstance.post('tickets/' + this.props.data.id+'/comment',{
                text:text
            },
            {
                cancelToken:this.state.source.token
            })
            .then(response => this.on_comment_add())
            .catch(err => {
                if (err.response?.status === 401) {
                    logOut(this.props); 
                }
            })
        }
    }

    onTextChanged(e) {
        this.setState({
            text: e.target.value
        })
    }
    make_comments() {
        let data = this.state.comments
        let arr = [];
        let index = 0;
        data.forEach(element => {
            arr.push(
                <div className="comment_item" key={element.id + 10}>
                    <div className="comment_info_container">
                        <label className="comment_user_name_label">{element.user.username}</label>
                        <label className="comment_user_name_label">{element.user.role}</label>
                    </div>
                    <p className="comment">{element.text}</p>
                    <label className="time_label">{element.created_at}</label>
                </div>
            )
        });
        return arr;
    }

    render_stbs(){
        if(this.state.data.stbs.length > 0){
            return this.state.data.stbs.map((element,index) => {
                return(
                    <StbForm 
                        key={index + 1}
                        exists = {true} 
                        index = {index + 1}
                        stb_packages = {this.state.stb_packages} 
                        tv_brands = {this.state.tv_brands}
                        element = {element}
                        isEditable = {false}
                    /> 
               )
            })
        }
        return null;
    }
    render() {
        let info = this.make_info()
        let comments = this.make_comments();
        let stbs = this.render_stbs();
        return (
            <TableRow ref={this.wrapper}>
                <TableCell colSpan={12} className="ExpanderRow">
                    <Table striped bordered hover variant="dark" responsive={true} size="lg">
                        <tbody>
                            {info}
                        </tbody>
                    </Table>
                    {this.state.data.onu  && <Onu element = {this.state.data.onu} internet_packages = {this.state.internet_packages}/>}
                    { this.state.data.stbs.length > 0 && <div>STBS</div>}
                    {stbs}
                    <div className="comments">
                        <p id="title">კომენტარები</p>
                        {comments}
                    </div>
                    <div className="comment_input_box">
                        <textarea type="text" id="input_comment" name="fname" onChange={(e) => this.onTextChanged(e)} value={this.state.text}></textarea >
                        <div id="add_btn_box">
                            <Button className="btn-secondary" id="add_comment_btn" onClick={(e) => this.add_comment()} >კომენტარის დამატება</Button>
                        </div>
                    </div>
                </TableCell>
                
            </TableRow>
        )
    }
}

export default ExpandableRow